import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import getUserBookings from "../Home/getUserBookings";
import getBookingStep from "../Home/getBookingStep";
import getSpecificBooking from "../Home/getSpecificBooking";

import { LoadingWheel } from "../../styles/loading";
import { HomeBanner } from "../../styles/banners";

//import HomePreSigned from "./HomePreSigned";
//import HomeSigned from "./HomeSigned";
//import HomePostInstalation from "./HomePostInstalation";
//import HomePostTermino from "./HomePostTermino";
import Footer from "../../styles/footers";

import { AlignedBoxSubTitle, AlignedBoxTitle, BoxSubTitle, BoxTitle } from "../../styles/texts";

import {
  UserData,
  UserBooking,
  SpecificBooking,
} from "../../types/responseTypes";
//import HomePendind2nd from "./HomePending2nd";

 
const Steps: React.FC = () => {
  const location = useLocation();
  //console.log("location: ", location); 
  const mockUserData: UserData = {
    id: "123",
    firstName: "John",
    lastName: "Doe",
    email: "john.doe@example.com",
    phone: "123-456-7890",
    rut: "12345678-9",
  };

  const userData = mockUserData;
  //const { userData } = location.state as { userData: UserData | null};

  const [userBookings, setUserBookings] = useState<UserBooking[]>([]);
  const [selectedBookingIndex, setSelectedBookingIndex] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [bookingStep, setBookingStep] = useState<number>(-1);
  const [bookingSubStep, setBookingSubStep] = useState<number>(0);
  const [specificBooking, setSpecificBooking] = useState<SpecificBooking | null>(null);
  

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const bookings = await getUserBookings();
        setUserBookings(bookings);

        if (bookings.length > 0) {
          setSelectedBookingIndex(0);
        }
      } catch (error) {
        console.error("Error fetching user bookings:", error);
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    const fetchBookingData = async () => {
      if (userBookings.length > 0 && userBookings[0].bookingId) {
        await fetchSpecificBookingAndStep(selectedBookingIndex);
        setLoading(false); // Set loading to false once data is fully fetched
      }
    };

    fetchBookingData();
  }, [userBookings, selectedBookingIndex]);

  const fetchSpecificBookingAndStep = async (index: number) => {
    const booking = userBookings[index];
    console.log("current booking: ", booking);
    if (!booking || !booking.bookingId) {
      console.error("Invalid booking data or bookingId is undefined");
      return;
    }

    try {
      const specificBookingData = await getSpecificBooking(booking.bookingId);
      console.log("specific booking data: ", specificBookingData);
      setSpecificBooking(specificBookingData);

      const step = await getBookingStep(booking);
      setBookingStep(step);
    } catch (error) {
      console.error("Error fetching specific booking or booking step:", error);
    }
  };

  const handleSelectBooking = async (index: number) => {
    setSelectedBookingIndex(index);
    setLoading(true);
    await fetchSpecificBookingAndStep(index);
    setLoading(false);
  };

  
  
  const distribuidor = "Enel";
  
  console.log("STEPS | userBookings: ", userBookings);
  console.log("STEPS | userData: ", userData);
  console.log("STEPS | selectedBookingIndex: ", selectedBookingIndex);
  console.log("STEPS | bookingStep: ", bookingStep);
  console.log("STEPS | specificBooking: ", specificBooking);

  //const [bookingStep, setColumn] = useState<number>(bookingStep ? bookingStep : 0);
  


  const STEPS_INFO = [
    {
      Step: 1,
      Title: "Preparación", 
      Date: "2 — 16 Ago", 
      Badge: bookingStep === 1 ? "Etapa Actual" : null,
      Substeps: [
        {
          Substep: 1,
          Title: "Onboarding", 
          Date: "48 horas desde firmar", 
          Badge: (bookingStep === 1 && bookingSubStep === 1) ? "Paso actual" : (bookingStep >= 1 || (bookingStep === 1 && bookingSubStep > 1)) ? "Check" : null,
          Description: "Llamada con tu experto solar quien te explicará que se viene, coordinará fechas y resolverá cualquier duda que tengas.",
        },
        {
          Substep: 2,
          Title: "Ingreso solicitud de conexión", 
          Date: "72 horas desde firmar", 
          Badge: (bookingStep === 1 && bookingSubStep === 2) ? "Paso actual" : (bookingStep >= 1 || (bookingStep === 1 && bookingSubStep > 2)) ? "Check" : null,
          Description: `Solicitud a ${distribuidor} para conectar tu sistema solar a la red. El tiempo de respuesta depende de varios factores, pero debería tomar entre 5 y 20 días hábiles.`,
        },
        {
          Substep: 3,
          Title: "Visita pre-instalación", 
          Date: "2 semanas desde firmar", 
          Badge: (bookingStep === 1 && bookingSubStep === 3) ? "Paso actual" : (bookingStep >= 1 || (bookingStep === 1 && bookingSubStep > 3)) ? "Check" : null,
          Description: "Estamos a la espera de la visita pre-instalación. En esta visita, el equipo técnico revisa los techos, el tablero general de la casa, el lugar donde se ubicará el inversor, la ruta de canalización, etc. Recomendamos que te encuentres en tu casa para quee revises y estés de acuerdo con los detalles del sistema."
        },
        {
          Substep: 4,
          Title: "Despacho de equipos", 
          Date: "3 días antes de la instalación", 
          Badge: (bookingStep === 1 && bookingSubStep === 4) ? "Paso actual" : (bookingStep >= 1 || (bookingStep === 1 && bookingSubStep > 4)) ? "Check" : null,
          Description: "Despacharemos los paneles e inversor a tu casa. Solo necesitamos un espacio cerrado para dejar las cajas. En caso que tengas niños, por favor ten precaución para evitar cualquier accidente.",
        },
      ]
    },
    {
      Step: 2,
      Title: "Instalación",
      Date: "18 — 21 de ago",
      Substeps: [
        {
          Substep: 1,
          Title: "Instalación de Paneles",
          Date: "5 días",
          Badge: (bookingStep === 1 && bookingSubStep === 1) ? "Paso actual" : (bookingStep >= 1 || (bookingStep === 1 && bookingSubStep > 1)) ? "Check" : null,
          Description: "Prepárate para unos días con un poco más de movimiento (y ruido) en tu casa. Los paneles quedarán generando energía pero todavía no podemos inyectar al sistema."
        },
        {
          Substep: 2,
          Title: "Detalles y revisión final",
          Date: "14 días desde la instalación",
          Description: "En caso que hayan quedado detalles durante la instalación, te contactaremos para coordinar una fecha para realizarlos. Hacemos una revisión final al sistema para verificar que se encuentra funcionando correctamente."
        }
      ]
    },
    {
      Step: 3,
      Title: "Permisos",
      Date: "22 de ago — 21 de sept",
      Substeps: [
        {
          Substep: 1,
          Title: "Preparación de informe",
          Date: "5 días desde la revisión final",
          Description: "Necesitamos que la SEC (Superintendencia de Electricidad y Combustible) confirme que tus paneles solares cumplen con la regulación actual. Para esto ingresaremos un informe incluyendo un registro fotográfico, planos eléctricos y otros detalles.",
        },
        {
          Substep: 2,
          Title: "Aprobación TE4",
          Date: "1 mes desde la revisión final",
          Description: "La respuesta de la SEC puede ser afirmativa o puede solicitar que se hagan algunas modificaciones menores en la instalación. Si es así, te avisaremos para coordinar una fecha para realizar los trabajos necesarios.",
        }
      ],
    },
    {
      Step: 4,
      Title: "Conexión",
      Date: "22 — 28 de sept",
      Substeps: [
        {
          Substep: 1,
          Title: `Firma de contrato con ${distribuidor}`,
          Date: "1 semana después de la recepción del TE4",
          Description: `Tu y ${distribuidor} firman un contrato para que ellos compren todos los excedentes de energía que inyectes a la red. No te preocupes, te vamos a enviar todo de forma digital.`,
        },
        {
          Substep: 2,
          Title: "Cambio de medidor",
          Date: "1 semana después de la firma de contrato",
          Description: "Una vez aprobado el contrato, un especialista de <distribuidor> te visitará para cambiar el medidor por uno bidireccional. Estos miden tanto la energía que consumes como la que inyectas. El proceso de cambio es bastante rápido (aprox 1 hora).",
        },
        {
          Substep: 3,
          Title: "Protocolo de conexión",
          Date: "1 semana después del cambio de medidor",
          Description: `Te iremos a visitar junto a un especialista de ${distribuidor}, para realizar unas pruebas de funcionamiento del sistema solar.`,
        },
        {
          Substep: 4,
          Title: "Funcionamiento!",
          Date: "",
          Description: "Tu sistema solar ya está en operación. Cada vez que veas tus paneles, acuérdate que estás ahorrando y ayudando al mundo al reducir tus emisiones. Recuerda que nos puedes contactar ante cualquier duda que tengas.",
        }
      ],
    }
  ];

  return (
    <div>
      
      <HomeBanner
        userBookings={userBookings}
        userData={userData}
        selectedBookingIndex={selectedBookingIndex}
        onSelectBooking={handleSelectBooking}
        backLink="/"
      />

      <div key="bookingStep" className="grid grid-cols-4 h-full">
        {STEPS_INFO.map((step, stepKey) => {
          return (
            <div 
              key={stepKey} 
              className="col-span-1 w-full h-full items-center"
              style={{
                opacity: bookingStep > step.Step ? 0.5 : 1,
                backgroundColor: bookingStep > step.Step ? '#F3F4F6' : 'transparent',
              }}
            >
              {/* Column Header */}
              <div className="flex flex-row w-full h-100 border border-gray-300 justify-between items-center p-4">
                <div className="flex flex-col gap-1 items-start">
                  <BoxTitle fontSize="24px">{step.Title}</BoxTitle>
                  <BoxSubTitle fontSize="18px">{step.Date}</BoxSubTitle>
                </div>
                {bookingStep === step.Step ? (
                    <div className="bg-[#DEE4FF] text-[#5A6ED5] font-medium w-[120px] h-[27px] p-[6px_10px] rounded-[16px] flex items-center justify-center">
                      Etapa actual
                    </div>
                  ) : (bookingStep > step.Step) ? (
                    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="12" fill="#5A6ED5" />
                    <path d="M6 12L10 16L18 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  ) : null
                }
              </div>

              {/* Substeps */}
              {step.Substeps.map((substep, subIndex) => (
                <div
                  key={subIndex}
                  className="flex flex-col items-start gap-2 border border-gray-300 p-4"
                  style={{
                    opacity: bookingStep > step.Step || (bookingStep === step.Step && bookingSubStep > substep.Substep) ? 0.5 : 1,
                    backgroundColor: bookingStep > step.Step || (bookingStep === step.Step && bookingSubStep > substep.Substep) ? '#F3F4F6' : 'transparent',
                  }}
                >
                  <div className="flex flex-row w-full h-100 justify-between items-center">
                    <div className="flex flex-col items-start">
                      <AlignedBoxTitle fontSize="18px">{substep.Title}</AlignedBoxTitle>
                      <AlignedBoxSubTitle fontSize="14px">{substep.Date}</AlignedBoxSubTitle>
                    </div>
                    {bookingStep === step.Step && bookingSubStep === substep.Substep ? (
                      <div className="bg-[#DEE4FF] text-[#5A6ED5] font-medium w-[120px] h-[27px] p-[6px_10px] rounded-[16px] flex items-center justify-center">
                        Paso actual
                      </div>
                    ) : bookingStep > step.Step || (bookingStep === step.Step && bookingSubStep > substep.Substep) ? (
                      <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="12" fill="#5A6ED5" />
                        <path d="M6 12L10 16L18 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    ) : null}
                  </div>
                  <p className="font-montserrat text-base font-normal leading-5 text-left decoration-skip-ink-none">
                    {substep.Description}
                  </p>
                </div>
              ))}
            </div>
          );
        })}  
      </div>

      <div className="flex justify-center mt-10">
        <Footer/>
      </div>
      
    </div>
  );
};

export default Steps;


